import React, { useMemo } from 'react';
import TextFieldCFormik from 'src/components/ui/TextField/connecotrs/TextFieldCFormik';
import AutocompleteCFormik from 'src/components/ui/Autocomplete/connectors/AutocompleteCFormik';

import TypedField from '..';
import PropTypes from 'prop-types';

const TypedFieldMemo = React.memo(TypedField);

const TypedFieldCFormik = (props) => {
	const {
		name,
		textFormat = '+7 (###) ###-##-##',
		autocomplete,
		textfield,
		...rest
	} = props;

	const connectParams = useMemo(() => {
		return {
			textfield: {
				name: `${name}.text`,
				format: textFormat,
				...textfield,
			},
			autocomplete: {
				name: `${name}.type`,
				...autocomplete,
			},
		};
	}, [name, textFormat, autocomplete, textfield]);

	return (
		<TypedFieldMemo
			TextFieldRP={TextFieldCFormik}
			AutocompleteRP={AutocompleteCFormik}
			{...connectParams}
			{...rest}
		/>
	);
};

TypedFieldCFormik.propTypes = {
	...TypedField.propTypes,
	textFormat: PropTypes.string,
};

export default TypedFieldCFormik;
